/* eslint-disable import/prefer-default-export */
import * as React from 'react'
import type { StepProps } from '../../models'
import * as styles from '../../review/review.styl'
import Button, { SubmitButton } from '@src/components/common/button'
import { Routes } from '@src/constants'

export const ReviewAndSaveFooter: React.FC<StepProps> = (props: StepProps) => {
  const { steps, stepId, history, switchStep } = props

  function previousStep() {
    if (steps[stepId - 1]) {
      switchStep(stepId - 1)
    }
  }

  function saveButtonClick() {
    history.push(Routes?.pages?.sources?.cloud?.path)
  }

  return (
    <div className={styles.buttonWrapper} role="button-wrapper">
      <Button
        title={'BACK'}
        className={styles.backButton}
        onClick={previousStep}
        role="back-button"
      />
      <SubmitButton
        title={'DONE'}
        className={styles.nextButton}
        onClick={saveButtonClick}
        role="next-button"
      />
    </div>
  )
}
